import script from "./ProjectItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectItem.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectItem.vue?vue&type=style&index=0&id=777294ba&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-777294ba"]])

export default __exports__